export default "__VITE_ASSET__RoDZzMC6__"